import React, { useEffect, useState } from 'react';
import { FormTextField } from '../../common/Form/FormTextField';
import { Button, Grid, Stack } from '@mui/material';

export default function AddUpdateForm({ id, isEdit = false, selectedCodec, onAction }) {
  const [codecId, setCodecId] = useState();
  const [systemName, setSystemName] = useState();

  useEffect(() => {
    if (isEdit) {
      setCodecId(selectedCodec?.ID);
      setSystemName(selectedCodec?.SYSTEM_NAME);
    }
  }, [isEdit, selectedCodec]);

  return (
    <Stack id={`${id}__stack_wrapper`} direction={'column'} gap={2} mt={2}>
      {
        <Grid
          id={`${id}__grid_container`}
          container
          direction="column"
          spacing={2}
          sx={{
            justifyContent: 'center',
          }}
        >
          <Grid item xs={12} xl={3} id={`${id}__grid_item_systemName`}>
            <FormTextField
              id={`${id}__inputText_systemName`}
              label="System Name"
              required
              value={systemName}
              placeholder="System Name"
              onChange={(value) => setSystemName(value)}
              textAlign={{ xs: 'start' }}
              labelGridProps={{ xs: 12, md: 2 }}
              inputGridProps={{ xs: 12, md: 10 }}
            />
          </Grid>
          <Grid item xs={12} xl={3} id={`${id}__grid_item_codecId`}>
            <FormTextField
              id={`${id}__inputText_codecId`}
              label="Codec ID"
              required
              value={codecId}
              placeholder="Codec ID"
              disabled={isEdit}
              onChange={(value) => setCodecId(value)}
              textAlign={{ xs: 'start' }}
              labelGridProps={{ xs: 12, md: 2 }}
              inputGridProps={{ xs: 12, md: 10 }}
            />
          </Grid>
          <Grid
            id={`${id}__grid_item_actions`}
            item
            xs={12}
            xl={12}
            sx={{ p: 0, alignSelf: 'flex-end' }}
          >
            <Button
              id={`${id}__button_${isEdit ? 'update' : 'add'}`}
              className="myOdu__button primary"
              variant="outlined"
              sx={{ mt: 1 }}
              onClick={() =>
                onAction({
                  id: codecId,
                  name: systemName,
                })
              }
              disabled={
                !codecId ||
                !systemName ||
                (isEdit &&
                  codecId === selectedCodec?.ID &&
                  systemName === selectedCodec?.SYSTEM_NAME)
              }
            >
              {isEdit ? 'Update' : 'Add'}
            </Button>
          </Grid>
        </Grid>
      }
    </Stack>
  );
}
